import { Helmet } from 'react-helmet'
import styled from 'styled-components'
import { Spacing } from '../../styles'
import { BodyMedium, TitleLarge } from '../atoms/typography/Typography'

const Container = styled.main`
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: ${Spacing._8};
    padding: ${Spacing._24};
    text-align: center;
`

const SharingUnavailableView = () => (
    <Container>
        <Helmet>
            <title>Sharing unavailable</title>
            <meta content="Sharing unavailable" property="og:title" />
            <meta content="Shared items are no longer available." property="og:description" />
        </Helmet>
        <TitleLarge>Sharing unavailable</TitleLarge>
        <BodyMedium color="light">Shared items are no longer available.</BodyMedium>
    </Container>
)

export default SharingUnavailableView
